// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"0d730bfd","315":"abe960d6","407":"654b8015","453":"00f1ce48","536":"ac48c6e7"}[chunkId] + ".chunk.js";
};